import { Component } from '@angular/core';

@Component({
  selector: 'svg-project',
  standalone: true,
  template: `
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor">
      <path
        d="m3 6v8h5.6347656l3.3652344 5.908203v7.091797h8v-8h-6.216797l-2.845703-5h.0625v-3h10v3h8v-8h-8v3h-10v-3zm2 2h4v4h-4zm18 0h4v4h-4zm-8.582031 13h3.582031v4h-4v-3.761719z" />
    </svg>
  `,
  styleUrl: './svg.style.scss',
})
export class SvgProjectComponent {}
